<template>
	<div class="text">
		<p class="head">更新时间:2022年2月</p>
		<p class="head">版本号:V1.0</p>
			<p class="head">一、前言</p>
			<p>欢迎您使用芝麻招工增值服务!</p>
			<p>为使用芝麻招工增值服务(简称本服务”您(简称"您或“用户”应当阅读并遵守芝麻招工《增值服务协议》(简称“本协议)。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议。并选择接受或不接受。</p>
			<p>除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您购买或使用芝麻招工软件内的任何收费服务，即视为您已阅读并同意本协议的约束。</p>
			
			<p class="head">二、协议条款的确认和接受</p>
			<p>2.1条款的接受</p>
			<p>在用户决定使用相关增值服务之前请仔细阅读本收费协议条款。用户必须在完全同意以下条款的前提下，才能进行购买程序。芝麻招工将根据以下收费协议条款为用户提供增值服务。用户在享受芝麻招工增值服务时必须完全、严格遵守本协议条款。</p>
			<p>2.2协议适用主体范围</p>
			<p>芝麻招工提供的网络服务采用收费与免费结合的方式，用户须先成为芝麻招工普通注册用户之后，才能继续进行购买服务。通过购买程序支付费用后，用户就可以轻松享受芝麻招工增值服务(招聘用户需要完成企业认证方可购买招聘方面的增值服务)。在进入购买程序之前，请用户首先同意并接受以下服务条款。</p>
			<p>2.3本协议内容</p>
			<p>本协议为您与芝麻招工《用户协议》的补充协议，是其不可分割的组成部分，与其构成统一整体。本收费协议中未约定事项以芝麻招工《用户协议》中的约定为准。本协议与前述协议存在冲突的，以本协议为准。</p>
			<p>本协议内容同时包括芝麻招工可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，用户同样应当遵守。</p>
			<p>2.4条款的更新</p>
			<p>芝麻招工有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改服务条款。芝麻招工有权就本协议随时更新，并在软件内或通过您留下的联系方式通知您。用户的权利以及义务的表述、购买程序及收费标准均以最新的服务条款为准。用户如果不同意该条款的修改并不影响已发生责任及义务的承担;如果用户在条款变更后继续访问或使用芝麻招工，则视为用户已经接受对本协议的修改。</p>
			
			<p class="head">三、服务说明</p>
			<p>3.1增值服务，指按照芝麻招工的指定方式支付一定服务费用之后，用户可以享有由芝麻招工或第三方提供的在芝麻招工平台虚拟道具、服务、求职/招聘方面特权等服务(以下简称“本服务)。</p>
			<p>3.2芝麻招工可能会根据不同的产品及服务类型，推出不同的增值服务类型目前，芝麻招工提供定的增值服务包括VIP账号、经纪人账号等。</p>
			<p>3.3芝麻招工可能会根据用户及市场的需求、产品及服务类型的变化等各种因素，对现有增值服务种类、功能、价格、权益进行调整以及不断推出新的增值服务种类。具体增值服务种类及服务内容及费用标准以相关服务页面公布、实际提供的内容为准。用户可以自行根据需要选择相应服务。</p>
			<p>3.4用户可通过登录芝麻招工，免费查询其消费的服务的详情(包括其购买的增值服务名称，购买时间，标示价格、即时服务状态等)。</p>
			<p>3.5芝麻招工对外售卖的所有增值服务均为辅助性工具，不构成对招聘效果的任何保证或担保。</p>
			<p>3.6用户理解并同意芝麻招工有权基于交易安全、运营策略、行业惯例等方面的考虑设定涉及交易的相关限制和提醒事项包括但不限于交易时间、交易限额、交易次数等。</p>
			
			<p class="head">四、收费标准及服务开通</p>
			<p>4.1本服务芝麻招工提供的增值服务，用户领在按照本服务的收费标准支付相应费用后，方可使用本服务</p>
			<p>4.2收费费用标准:服务费用的具体资费政策以芝麻招工软件内届时公布的内容为准，芝麻招工有权随时修改本服务的资费政策(包括但不限于服务价格)、订购方式，并在芝麻招工软件内予以公布。</p>
			<p>4.3如用户不同意按照届时芝麻招工制定(修改)并公布的资费政策(包括但不限干服务价格)支付服务费用或不同意按照届时芝麻招工制定(修改)并公布的订购方式订购本服务，用户将不能获得本服务任何部分或全部，如已获得本服务用户应自行主动取消本服务，但芝麻招工有权不予退还用户已支付的任何服务费用，但用户已经付费取得的服务内容服务时长等，可以在原有范围内使用，如因服务内容变更导致无法继续使用的，用户可以申请退还未使用部分的费用。</p>
			<p>4.4服务开通</p>
			<p>重要约定:用户通过网银微信支付、手机支付宝支付或苹果第三方支付等方用户充值一旦成功，充值即确定完成，芝麻招工将不提供任何更改、修正服务，用户不得向芝麻招工要求退还充值金额。</p>
			<p>4.5违约行为</p>
			<p>非经芝麻招工许可，用户不得通过以下方式开通/获取本服务，否则将构成违约。</p>
			<p>以营利、经营等非个人使用的目的为自己或他人开通本服务;</p>
			<p>通过任何机器人软件，蜘蛛软件，爬虫软件等任何程序、软件方式为自己或他人开通本服务。</p>
			<p>通过任何不正当手段或以违反诚实信用原则的方式(包括但不限于利用平台可能存在的漏洞、绕开平台的商业规则/技术规则等)为自己或他人开通/获取本服务;通过非芝麻招工指定的方式为自己或他人开通本服务;</p>
			<p>通过侵犯芝麻招工或他人合法权益的方式为自己或他人开通本服务，如通过第三方平台由他人代充代付;。通过其他违反芝麻招工《用户协议》《职位信息发布规则》或相关法律、行政法规、国家政策等的方式为自己或他人开通/获取本服务。</p>
			<p>4.6服务期限</p>
			<p>本服务中相关增值产品可能存在相关期限，如有期限限制以用户自行选择并支付相应服务费用的期限为准，用户也可以登录平台相关页面进行查询。</p>
			<p>用户知悉用户行为(包括但不限干购买/使用/兑换/激活产品，注销账号等)可能影响本服务中相关产品或道具的有效期，例如，注销未成功的用户，在注销申请期间(冷静期内)已生效的增值服务将继续生效，有效期不予暂停。因已激活的产品权益自然经过有效期的，芝麻招工不保证用户申请恢复该账号时相关产品权益持续有效。届时以产品页面显示或芝麻招工系统记录为准。</p>
			<p>4.7风险提示</p>
			<p>用户在使用芝麻招工购买增值服务时，用户必须仔细确认自己的帐号，若因为用户自身输入账号错误、操作不当或不了解充值计费方式等因素造成充错账号、错选服务项目等情形而损害自身权益，不得因此要求芝麻招工作任何补偿或赔偿。</p>
			<p>若用户以不正当的方式，非芝麻招工所指定的充值方式进行充值，芝麻招工不保证该充值顺利或者正确完成。若因此造成用户权益受损时，芝麻招工不会作任何补偿或赔偿，芝麻招工同时保留随时冻结或终止该用户账号资格及使用各项充值服务的权利。</p>
			<p>4.8费用退还</p>
			<p>芝麻招工平台提供的增值服务均为数字化商品，不支持七天无理由退款。相关服务一经购买/使用/兑换/激活，不可转让、退款、提现等(但因芝麻招工提供的增值服务存在质量瑕疵致使用户无法使用平台服务的、本协议另有约定、法律法规要求必须退款的或经芝麻招工判断后认为可以退款的除外，相关流程可咨询人工客服)。</p>
			
			<p class="head">五、用户权利及义务</p>
			<p>5.1重要约定</p>
			<p>用户不得通过未经芝麻招工授权许可的任何第三方平台或渠道(如淘宝、京东等平台上的店铺)购买芝麻招工提供的增值服务或产品:不得将账号提供给第三方进行代充代付，因违反前述约定导致用户隐私泄露的，用户应当自行承担相应后果;如给芝麻招工造成损失的，芝麻招工可以要求用户承担违约责任并赔偿损失。</p>
			<p>5.2违约情形</p>
			<p>用户同意不会采用收费或免费的方式，全部或部分地在任何公开场合展示用户购买的增值服务内容，除非用户的上述行为不会构成侵权。</p>
			<p>5.3用户在使用本服务时不得出现以下情况/从事以下活动，包括但不限于:</p>
			<p>发布、传送、传播、储存违反国家法律、危害国家安全统一社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容;</p>
			<p>发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容;</p>
			<p>虚构事实、隐瞒真相以误导、欺骗他人;</p>
			<p>发表、传送、传播广告信息及垃圾信息;</p>
			<p>滥用客服功能、骚扰客服人员或平台其他工作人员</p>
			<p>涉嫌从事其他违反法律法规、政策及公序良俗、社会公德等的行为;</p>
			<p>通过任何方式搜集本服务中其他用户的用户名电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户;</p>
			<p>通过本服务发布包含广告、宣传、促销等内容的信息。</p>
			<p>5.4对自己行为负责</p>
			<p>用户充分了解并同意，用户必须为自己注册账号下的一切行为负责，包括但不限于用户所发表的任何内容以及由此产生的任何后果。用户应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。</p>
			<p>若用户违反芝麻招工《用户协议》《职位信息发布规则》或本协议内容芝麻招工有权在未通知的情况下随时对其账号采取一定的处理措施，包括但不限干部分或全部冻结终止其账号使用资格的，用户不得因此要求芝麻招工作任何补偿或赔偿。</p>
			<p>5.5用户的权利与义务</p>
			<p>用户应自行角责妥善目正确地保管，使用，维护其在芝麻招工申请取得的账户及账户密码。用户应对其账户密码采取必要和有效的保密措施。非芝麻招工原因致使用户账户密码泄漏以及因用户保管、使用、维护不当造成损失的。芝麻招工无须承担与此有关的任何责任。</p>
			<p>用户明确了解并同意，本协议第2条款约定的付费方式为代收费运营商托收的付款方式，用户通过此种付费方式付费可能存在一定的商业风险(包括但不限于不法分子利用用户账户或银行卡等有价卡等进行违法活动)，该等风险均会给用户造成相应的经济损失，为此，用户同意芝麻招工在充分展行其在本协议项下全部义务及勒勉谨慎义务的前提下不对用户的前述风险和失承担任何责任;并目:芝麻招工不承担向不法分子追究侵权责任或者代其向用户承担损失的任何责任和义务。</p>
			
			<p class="head">六、变更及免责条款</p>
			<p>6.1芝麻招工有权随时修改本协议的任何条款一日本协议的内容发生变动，芝麻招工将会在网站上公布修改之后的协议内容，若用户不同意上述修改，则可以选择停止使用芝麻招工服务。芝麻招工也可选择通过其他适当方式(比如系统通知消息推送:平台公告)向用户通知修改内容，如果不同意芝麻招工对本协议相关条款所做的修改，用户有权停止使用芝麻招工服务。如果用户继续使用芝麻招工服务，则视为用户接受芝麻招工对本协议相关条款所做的修改。</p>
			<p>6.2用户充分了解并同意，由于互联网服务的特殊性，芝麻招工可能会按照相关法规、双方约定或在其他必要时，中止或终止向用户提供本服务，届时，芝麻招工会依法保护用户的合法权益。用户在此同意并确认:芝麻招工提供服务时可能会涉及到虚拟物品(包括但不限于道具、材料等)，该虚拟物品仅在服务运营期内有效，服务停止时，虚拟物品将随服务停止运营而消失，用户一经获得将不得以任何形式退还给芝麻招工。</p>
			
			<p class="head">七、服务的中断和终止</p>
			<p>7.1因发生芝麻招工不可抗拒的事由，如政府行为不可抗力，导致服务无法继续，芝麻招工将尽快通知用户，但不承担由此对用户造成的任何损失并不退还任何费用。</p>
			<p>7.2如用户严重违反本服务条款中的内容芝麻招工有权在不通知用户的情况下立即终止用户已购买的部分或所有服务，以及暂时或永久取消用户的芝麻招工账户和使用权限，但不退还任何已缴纳的服务费用。</p>
			<p>7.3重要约定:用户违反本协议第1条，通过未经芝麻招工授权的淘宝店铺等第三方平台或渠道进行代充代付购买芝麻招工产品或其他道具/服务等行为的，直接构成严重违约行为，芝麻招工有权终止用户购买的此等产品的使用权限，并不予退还相应的服务费用。</p>
			<p>7.4芝麻招工未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使芝麻招工随时有权要求用户继续展行义务并承担相应的违约责任。</p>
			
			<p class="head">八、违约责任</p>
			<p>8.1如因芝麻招工违反有关法律、法规或本协议项下的任何条款而给用户造成损失，芝麻招工同意承担由此造成的损害赔偿责任。但芝麻招工的赔偿责任亦以用户就使用服务所支付芝麻招工的价款为限。</p>
			<p>8.2用户若违反本协议或相关法令，导致芝麻招工或其关系企业，受雇人，受托人，代理人及其它相关展行辅助人因此而受到损害或支出费用(包括但不限于由法律诉讼、行政程序等所支出的诉讼费用、律师费用、实际遭受损失的费用等)，用户应负担损害赔偿责任。</p>
			<p>8.3对第三方损害的处理</p>
			<p>用户有违反本协议任何行为，导致任何第三方损害的，用户应当独立承担责任;芝麻招工因此遭受损失的，用户也应当一并赔偿。</p>
			<p>8.4处罚规则</p>
			<p>用户知悉并同意，如用户被举报、被芝麻招工发现或经芝麻招工独立判新认为用户存在/涉嫌违反国家法律法规/监管规定/政府政策、违反芝麻招工《用户协议》《职位信息发布规则》/本协议、扰乱本平台的运营秩序、破坏平台的招聘求职环境等行为的芝麻招工有权对其采取以下一项或多项处理措施:</p>
			<p>如本协议对此行为有单独条款约定处理方式的，按照该条款处理;</p>
			<p>无需通知用户而采取一种或多种措施制止用户的行为及行为产生的后果，包括但不限于如删除/屏蔽相关链接或内容、暂时/永久性冻结用户的账号、限制账户部分或全部的使用权限等;</p>
			<p>无需通知用户而中断或终止部分或全部服务且用户已支付的费用将不予退还且不提供任何形式的补偿/赔偿;</p>
			<p>如用户的行为使芝麻招工或/及其关联公司遭受任何损失的，用户应当承担全部损失赔偿责任并在芝麻招工要求的时限内完成费用支付。</p>
			<p>8.5特别提示</p>
			<p>如因用户违反本协议、被芝麻招工系统检测出异常操作行为的(包括但不限于短时间内多次购买/取消订单、频繁、大量发布新职位等)或被芝麻招工发现利用规则漏洞获取任何服务的，芝麻招工有权在不通知用户的情况下，按照相关规定对其采取处罚措施，包括但不限于，暂时/永久禁封用户账号、将用户加入黑名单、限制用户使用部分或全部服务、拒绝为其退货/退款。</p>
			<p>部分用户因违反《用户协议》《职位信息发布规则》被限制使用的，包括但不限于禁言、限期冻结等，平台有权根据实际情况，将其所购买服务的有效期进行相应顺延(最终以页面显示为准)。</p>
			<p class="head">九、其他条款</p>
			<p>9.1本协议的订立、执行和解释及争议的解决均应用中国法律并受中国法院管辖。如本服务条款与中华人民共和国法律相抵触时，则该等条款将按法律规定重新修订，而其它条款则依旧有效并具有法律效力。</p>
			<p>9.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决;协商不成时，任何一方均可向芝麻招工所在地的人民法院提起诉讼。</p>
			<p>9.3本协议项下所有的通知均可通过软件内通知电子邮件短信或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人。</p>


	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '芝麻招工增值服务协议'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
